import breakpoints from '@/lib/navigation-breakpoints.js';

export default function () {
	const width = window.innerWidth || window.document.documentElement.clientWidth;

	return width < breakpoints.md;
}
